module.exports = global["surveylab_survey_saveItemInput"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./save-item-input.ts");